<template>
  <div class="page-document-keywords">
    <!-- Phones: its main action, as the "+" of the settings header. -->
    <PageMainAction :label="$t('page.admin-keywords.new-category')" @click="openAddCategory" />
    <div v-if="!isPhone" class="page-document-keywords__actions">
      <BaseRefreshButton :size="40" :pending="pending" @refresh="onRefresh" />
      <BaseButton @click.native="openAddCategory" has-icon-left class="page-document-keywords__add-category">
        <BaseIcon name="plus" />
        {{ $t('page.admin-keywords.add-category') }}
      </BaseButton>
    </div>
    <!-- Phones: the count line (docs/page-layout.md), the categories under it. -->
    <BasePhoneCountLine v-if="isPhone && keywords.length" class="page-document-keywords__count-line">
      <template #count>
        <span class="number-monospace">{{ keywordCount }}</span>
        {{ ' ' + $tc('basic-words.keywords', keywordCount) }}
      </template>
      <template #actions>
        <BaseRefreshButton :pending="pending" @refresh="onRefresh" />
      </template>
    </BasePhoneCountLine>
    <DocumentKeywordsTable />
    <AddCategoryDialog :hasColorChoice="true" ref="addCategoryDialog" @action-succeeded="onRefresh" />
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon.vue';
import DocumentKeywordsTable from '@/components/page-document-keywords/DocumentKeywordsTable';
import AddCategoryDialog from '@/components/page-admin-keywords/AddCategoryDialog.vue';
import BasePhoneCountLine from '@/components/base/BasePhoneCountLine.vue';
import PageMainAction from '@/components/layout/PageMainAction.vue';
import { viewport } from '@/util/viewport';
import BaseRefreshButton from '@/components/base/BaseRefreshButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PageAdminDocumentKeywords',
  components: {
    BaseRefreshButton,
    BaseIcon,
    BaseButton,
    BasePhoneCountLine,
    DocumentKeywordsTable,
    AddCategoryDialog,
    PageMainAction,
  },
  computed: {
    ...mapGetters('documentKeywords', ['keywords', 'pending']),
    isPhone() {
      return viewport.size === 'phone';
    },
    // As the categories list them (DocumentKeywordsList): blank values aren't keywords.
    keywordCount() {
      const listed = (keyword) => keyword && keyword.value !== null && keyword.value.trim() !== '';
      return (this.keywords || []).reduce(
        (sum, category) => sum + (category.documentKeywords || []).filter(listed).length,
        0,
      );
    },
  },
  methods: {
    ...mapActions('documentKeywords', ['getKeywords']),
    openAddCategory() {
      this.$refs.addCategoryDialog.openDialog();
    },
    onRefresh() {
      this.getKeywords();
    },
  },
};
</script>

<style lang="scss">
.page-document-keywords {
  &__header {
    background: $color-white;
    box-shadow: $shadow-dropdown;
    justify-content: space-between;
    display: flex;
    align-items: center;
    min-height: $header-height;
    position: sticky;
    top: $menu-top-bar-height;
    z-index: 3;
    padding: 0px 32px;
  }

  &__head {
    display: flex;
    align-items: center;
  }

  &__content {
    background: $color-white;
    display: flex;
    flex-wrap: wrap;
    flex: auto;
    flex-direction: row;
    margin: 32px;
    padding-top: 32px;
    border-radius: 10px;

    // Phones: the categories are cards of their own (KeywordsPhoneCategory), under the count line.
    @include screen-below('tablet') {
      margin: 0 $phone-page-gutter $phone-page-gutter;
      padding-top: 0;
      background: none;
    }
  }
  &__count-line {
    margin: $space-xl $phone-page-gutter 12px;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 32px 32px;
    padding-bottom: 0;
    gap: 8px;
  }
}
</style>
